import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=0c5d7a7a&scoped=true"
import script from "./SignUpModal.vue?vue&type=script&lang=js"
export * from "./SignUpModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=0c5d7a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5d7a7a",
  null
  
)

export default component.exports